import config from 'config';

const LOAD = 'horse-racing/my-stable-jockey-search/LOAD';
const LOAD_SUCCESS = 'horse-racing/my-jockey-trainer-search/LOAD_SUCCESS';
const LOAD_FAIL = 'horse-racing/my-stable-jockey-search/LOAD_FAIL';
const RESET = 'horse-racing/my-stable-jockey-search/RESET';

const initialState = {
  loaded: false,
  jockeySearchResults : []
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD:
      return {
        ...state,
        loading: true
      };
    case LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        jockeySearchResults: action.result
      };
    case LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      };
    case RESET:
      return {
        ...state,
        jockeySearchResults: [],
        searchText: ""
      }
    default:
      return state;
  }
}

export function resetJockeys() {
  return {
    type: RESET
  }
}

export function areJockeysLoaded() {

  return false;
}

export function loadJockeys(name) {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: (client) => name ? client.get(config.api.horseRacing.jockey, { params: {name}})
                              : Promise.resolve([])
  };
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/reducers/myStableJockeySearch.js